'use client';

import { useIntercomStore } from '@/lib/stores';

/**
 * Returns whether `window.Intercom` is loaded and callable.
 *
 *   null  — unknown (loader chunk hasn't published yet, e.g. feature flag off
 *           or still booting)
 *   true  — SDK ready, tours can fire
 *   false — loader gave up after the boot timeout, surface unavailable banner
 *
 * Backed by the Zustand intercom-store; subscribers re-render automatically
 * when `<IntercomMessengerLoader />` publishes a new value.
 */
export function useIntercomAvailable(): boolean | null {
  return useIntercomStore((s) => s.available);
}
